import styled, { css } from 'styled-components'
import { Button, colors } from '@microfrontends/react-components'

export const PrefixText = styled.div`
    width: auto;
    display: inline-flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding-left: 10px;
    min-width: 22px;
    height: 36px;
    color: ${colors.grey[50]};
`
export const InputDomain = styled.div<{ isInputDomain: boolean }>`
    display: flex;
    width: 100%;
    border: 1px solid ${colors.neutral[80]};
    border-radius: 6px;
    height: 40px;
    background-color: #fff;
    :hover {
        border: 1px solid #80adff;
    }
    :focus {
        border: 1px solid #0066ff;
    }
    &.focus {
        border: 1px solid #0066ff;
        button {
            border-left: 1px solid #0066ff;
        }
    }
    input {
        width: 100%;
        height: 36px;
        padding-left: 4px;
        border: none !important;
        &::placeholder {
            color: ${colors.grey[50]};
        }
        ${({ isInputDomain }) => {
            if (!isInputDomain) {
                return
            }
            return css`
                border-radius: 0;
            `
        }}
        :hover {
            border: none;
        }
        :focus {
            border: none;
        }
    }
`
export const InputArea = styled.div<{ nonePrefix: boolean }>`
    width: 90.5%;
    > div > div {
        top: 1px;
    }
    svg.remove-icon {
        top: 6px;
    }
    ${({ nonePrefix }) =>
        nonePrefix &&
        css`
            width: 100%;
            input {
                padding-left: 10px;
            }
        `}
`

export const SuggestItem = styled.div`
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
    img {
        width: 32px;
        height: 32px;
        margin-right: 8px;
    }
`
export const TagList = styled.div`
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -4px;
`
export const TagItem = styled.div`
    margin-right: 4px;
    margin-bottom: 4px;
`
export const MessageAlert = styled.div<{ isDisplay?: boolean }>`
    ${({ isDisplay }) =>
        !isDisplay &&
        css`
            display: none;
        `}
    span {
        display: block;
    }
`
export const StyledButton = styled(Button)<{ isMobile?: boolean }>`
    width: 9.5%;
    min-width: 60px;
    border-left: 1px solid #a2a6ac;
    opacity: 1;
    height: 38px;
    border-right: none;
    border-top: none;
    border-bottom: none;
    border-radius: 0 6px 6px 0;
    color: ${colors.grey[20]} !important;

    ${({ isMobile }) =>
        isMobile &&
        css`
            width: 16%;
        `}
`
